export default __webpack_public_path__ + "static/media/grid.7842c9fe.svg";